import React from "react";
import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import { CommonLayout } from "../components/CommonLayout";
import { WakingUpAnimation } from "components/WakingUpAnimation";

const router = createBrowserRouter([
  {
    path: "/",
    element: <CommonLayout menu={[]} />,
    children: [
      {
        path: "/",
        element: <WakingUpAnimation />,
      },
      {
        path: "*",
        element: <WakingUpAnimation />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/" replace={true} />,
  },
]);

export const NoRole = () => <RouterProvider router={router} />;
